/**
 * @file comicClassifyFilters.js
 * @description 漫画分类页筛选常量（与 classify 接口字段对齐）
 */

/** @typedef {'POPULARITY' | 'UPDATE_TIME'} ClassifySortType */

/**
 * @typedef {Object} ClassifyComicPayload
 * @property {number} [pageNum]
 * @property {number} [pageSize]
 * @property {number} [bigThemeCode]
 * @property {string[]} [themeArray]
 * @property {string} [regionCode]
 * @property {string} [serialStatus]
 * @property {string} [chargeType]
 * @property {ClassifySortType} [sortType]
 */

/**
 * @typedef {Object} ClassifyFilterOption
 * @property {string} value 空串表示「全部」
 * @property {string} label
 */

/** @type {ClassifyFilterOption[]} */
export const REGION_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '日本' },
]

/** classify 接口：日本地区编码 */
export const REGION_CODE_JAPAN = '1'

/** @type {ClassifyFilterOption[]} */
export const SERIAL_STATUS_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: '0', label: '连载' },
  { value: '1', label: '完结' },
]

/** @type {ClassifyFilterOption[]} */
export const CHARGE_TYPE_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: '0', label: '免费' },
]

/** @type {ClassifyFilterOption[]} */
export const SORT_TYPE_FILTER_OPTIONS = [
  { value: 'POPULARITY', label: '人气推荐' },
  { value: 'UPDATE_TIME', label: '更新时间' },
]
